// ============================================================
// ELC Shift — Uploads module entry point
//
// admin.html loads the bundle via <script src="/dist/uploads.js">
// and inline call sites use Uploads.budget.handleDrop() etc.
//
// Submodules:
//   - Uploads.shared      — parseMatrixSheet, suggestion helpers
//   - Uploads.match       — Levenshtein name + store matching (v94.0)
//   - Uploads.budget      — annual targets / budget xlsx upload
//   - Uploads.daily       — Head Office's daily xlsx (sales + addon combined)
//   - Uploads.addon       — standalone addon-actuals weekly bulk upload
//   - Uploads.historical  — one-time prior-year sales bootstrap (v90.0)
//   - Uploads.staff       — Amanah HR apply/cancel/status (v95.0)
//   - Uploads.rules       — AI rota generator rules engine (v96.0,
//                            +renderRulesPreview + DEFAULT_TRADING v97.0)
//   - Uploads.trading     — Trading pattern load + buildContext (v97.0)
//   - Uploads.balances    — TOIL + leave balance management (v100.0)
//   - Uploads.excel       — Multi-sheet xlsx export (v101.0)
//   - Uploads.devReports  — Dev tab: feedback/errors/audit/reveals/status (v102.0)
//   - Uploads.clockReview — Clock-log review + edit (v102.0)
//   - Uploads.rota        — AI rota generation + publish (v103.0)
//   - Uploads.kpi         — Area KPI scorecards (v103.0)
//   - Uploads.areas       — Area CRUD (v103.0)
//
// Build via build.js.
// ============================================================

import * as shared     from './shared.js';
import * as match      from './match.js';
import * as budget     from './budget.js';
import * as daily      from './daily.js';
import * as addon      from './addon.js';
import * as historical from './historical.js';
import * as staff      from './staff.js';
import * as rules      from './rules.js';
import * as trading    from './trading.js';
import * as balances   from './balances.js';
import * as excel      from './excel.js';
import * as devReports from './devReports.js';
import * as clockReview from './clockReview.js';
import * as rota       from './rota.js';
import * as kpi        from './kpi.js';
import * as areas      from './areas.js';
import * as stores      from './stores.js';
import * as logs      from './logs.js';
import * as compliance      from './compliance.js';
import * as checklists      from './checklists.js';
import * as delivery      from './delivery.js';
import * as balanceReconcile from './balanceReconcile.js';

export { shared, match, budget, daily, addon, historical, staff, rules, trading, balances, excel, devReports, clockReview, rota, kpi, areas, stores, logs, compliance, checklists, delivery, balanceReconcile };

// v104.0 (Sprint 16 — Final Sweep):
//   - Uploads.stores       — Store CRUD + hours
//   - Uploads.logs         — Log templates admin
//   - Uploads.compliance   — Compliance settings + scan + email
//   - Uploads.checklists   — Checklist templates
//   - Uploads.delivery     — Delivery schedule management
// + extensions to Uploads.staff / Uploads.budget / Uploads.devReports
